import {
  DashboardItemSettingsDto,
  KeyFinancialRatio,
  NetSavingsType,
  ValueSource,
  ValueType
} from '@unistocks/proxy/axios-client';
import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export const valueTypeOptions = mapEnumToOptions(ValueType, 'ValueType').filter(
  ({ value }) => value !== ValueType.All
);
export const valueSourceOptions = mapEnumToOptions(ValueSource, 'ValueSource');
export const netSavingsTypeOptions = mapEnumToOptions(NetSavingsType, 'NetSavingsType');
export const keyFinancialRatioOptions = mapEnumToOptions(KeyFinancialRatio, 'KeyFinancialRatio');

export const ensurePortfolioFilter = (
  settings: DashboardItemSettingsDto
): DashboardItemSettingsDto => {
  return {
    ...settings,
    portfolios: settings.portfolios ?? [],
    sections: settings.sections ?? [],
    assetTypes: settings.assetTypes ?? []
  };
};
